export default __webpack_public_path__ + "static/images11-972073f2d5da6197a92d90589ddb7b88.jpg";